import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    main: {
      flexGrow: 1,
      padding: '30px 20px',
    },

    videoTileContainer: {
      margin: '0 -15px',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      maxWidth: 980,

      [children('> div')]: {
        marginBottom: 30,
      },

      [media.desktop]: {
        justifyContent: 'flex-start',
        [children('> div')]: {
          marginBottom: 25,
        },
      },
    },

    onDemandGrid: {
      margin: '0 auto',

      [media.desktop]: {
        maxWidth: 875,
      },
    },

    carousel: {
      margin: '10px auto 0 auto',
      [media.desktop]: {
        marginTop: '45px',
      },
    },

    hr: {
      color: '#FFF',
      margin: '40px 0',

      [media.desktop]: {
        display: 'none',
      },
    },

    voiceOverBadge: {
      background: palette.red,
      color: '#FFF',
      padding: '5px 8px',
      borderRadius: 5,
      fontWeight: 'bold',
      fontSize: 16,
      wordBreak: 'keep-all',
    },
  });
};
